<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="sys-notice">
    <common-table
      url="/api/platform/getSysNoticeByPage"
      deleteUrl="/api/platform/deleteSysNoticeById"
      :column="column"
      :operate="operate"
      ref="table"
      :searchForm="searchForm"
      :searchButtons="buttons"
    >

    </common-table>
    <submit-form
      width="70%"
      :title="formTitle"
      :visible.sync="formVisible"
      :formData="formData"
      :items="items"
      :rules="rules"
      :action="action"
      addUrl="/api/platform/insertSysNotice"
      updateUrl="/api/platform/updateSysNotice"
      :onSubmitCallback="onSubmitCallback"
      :handleClose="handleClose"
    ></submit-form>
  </div>
</template>

<script>
  import utils from '../utils/utils'
    export default {
        name: "sys-notice",
      data(){
          return{
            column:[{
              prop:"type",
              label:"通知类型",
              formatter:this.typeFomatter
            },{
              prop:"title",
              label:"通知标题"
            },{
              prop:"publishTime",
              label:"发布时间",
              dateFormatter:true
            },{
              prop:"isWork",
              label:"发布状态",
              formatter:this.isWorkFormatter
            },{
              prop:"operateName",
              label:"操作员"
            }],
            operate:[{
              key:"edit",
              name:"编辑",
              handleClick:this.editRow
            },{
              key:"delete",
              name:"删除"
            },{
              key:"publish",
              condition:{
                prop:"isWork",
                label:[{
                  value:"1",
                  name:"取消发布"
                },{
                  value:"0",
                  name:"发布"
                }]
              },
              handleClick:this.publishRow
            }],

            searchForm:{

            },
            buttons:[{
              key:"add",
              name:"新增",
              handleClick:this.onCreate
            }],
            formTitle:"",
            formVisible:false,
            action:"",
            formData:{
              title:"",
              content:"",
              type:"1",
              isWork:"0"
            },
            items:[{
              key:"title",
              name:"title",
              label:"通知标题",
              type:"input",
              prop:"title"
            },{
              key:"content",
              name:"content",
              label:"通知内容",
              type:"editor",
              prop:"content",
              editorOption:{}
            },{
              key:"type",
              name:"type",
              label:"通知方式",
              type:"radio",
              options:[{
                value:"1",
                label:"系统通知（我的频道>我的消息中接受）"
              },{
                value:"2",
                label:"系统公告（商城频道>通知公告中展示）"
              }]
            }],
            rules:{
              title:[{required: true, message: '请输入通知标题', trigger: 'blur'}],
              content:[{required: true, message: '请输入通知内容', trigger: 'blur'}],
            },
          }
      },
      methods:{
        onCreate(){
          this.formTitle = "新增";
          this.formVisible = true;
          this.action = "add";
        },
        onSubmitCallback(){
          this.$refs['table'].getData();
        },
        handleClose(){
          this.formData = {
            title:"",
            content:"",
            type:"1",
            isWork:"0"
          }
        },
        editRow(row){
          this.formTitle = "编辑";
          this.formVisible = true;
          this.action = "update";
          this.formData = {
            title:row.title,
            content:row.content,
            type:row.type,
            id:row.id,
            isWork:row.isWork
          }
          this.items[1].fileImageList = [{url:row.image}]
        },
        publishRow(row){
          let formData = new FormData();
          if(row.isWork == "0"){
            formData.append("isWork","1")
          }else{
            formData.append("isWork","0")
          }
          formData.append("id",row.id)
          utils.axiosMethods({
            method:"POST",
            data:formData,
            url:"/api/platform/updateSysNotice",
            callback:(res) => {
              this.$message.success("操作成功");
              this.$refs['table'].getData();
            }
          })
        },
        isWorkFormatter(row, column, cellValue, index){
          return cellValue == "1" ? "已发布":"未发布"
        },
        typeFomatter(row, column, cellValue, index){
          return cellValue == "1" ? "站内信":"系统公告"
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sysNotice.vue